module.exports = __webpack_public_path__ + "static/img/02450_1.d5b4ecc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02450_1.jpg
// module id = NUgT
// module chunks = 1